import script from "./FooterDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterDescription.vue?vue&type=script&setup=true&lang=js"

import "./FooterDescription.vue?vue&type=style&index=0&id=9dc57c80&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9dc57c80"]])

export default __exports__